import React, { useEffect, useState } from "react";
import { ReactComponent as DigitalDownload } from "./assets/digitalDownload.svg";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import CircularProgress from "@material-ui/core/CircularProgress";
const DigitalDownloadNotification = ({ order }) => {
  const language = useSelector((state) => state.store.language);
  const history = useHistory();
  return (
    <div
      onClick={() =>
        order.payment_complete &&
        history.push(`/download/${order.tracking_id}`, {
          fromTracking: true,
        })
      }
      style={{
        backgroundColor: "white",
        minHeight: 70,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderTop: `1px solid #0099cc`,
        borderBottom: `1px solid #0099cc`,
        cursor: order.payment_complete && "pointer",
      }}
    >
      <DigitalDownload
        style={{ width: 20, height: 20, flex: 0.25, marginBottom: 5 }}
      />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          flex: 1,
        }}
      >
        <div>
          <p
            style={{
              textDecoration: "underline",
              margin: 0,
              fontWeight: "bold",
              color: "#0099cc",
            }}
          >
            {language === "english"
              ? "Download your files here"
              : "قم بتحميل ملفاتك هنا"}
          </p>
          {!order.payment_complete && (
            <div style={{ color: "#999", fontWeight: "bold" }}>
              <span>
                <CircularProgress
                  color="primary"
                  style={{
                    width: 10,
                    height: 10,
                    marginRight: language == "english" && 5,
                    marginLeft: language == "arabic" && 5,
                  }}
                />
              </span>{" "}
              {language == "english"
                ? "Awaiting verification"
                : "بإنتظار الموافقة"}
            </div>
          )}
        </div>
        <span
          style={{
            marginRight: language === "english" && 15,
            marginLeft: language === "arabic" && 15,
          }}
        >
          {language === "english" ? (
            <NavigateNextOutlinedIcon style={{ color: "#0099cc" }} />
          ) : (
            <NavigateBeforeOutlinedIcon style={{ color: "#0099cc" }} />
          )}
        </span>
      </div>
    </div>
  );
};

export default DigitalDownloadNotification;
